// State tax rates (simplified – top marginal rates for 2025)
// TODO - Handle states that use brackets.
export const STATE_TAX_RATES: Record<string, number> = {
    // No state income tax
    AK: 0,
    FL: 0,
    NV: 0,
    NH: 0,
    SD: 0,
    TN: 0,
    TX: 0,
    WA: 0,
    WY: 0,

    // Flat rate / nearly flat rate states
    CO: 0.044,
    IL: 0.0495,
    IN: 0.03,
    KY: 0.04,
    MA: 0.05,
    MI: 0.0425,
    NC: 0.0425,
    PA: 0.0307,
    UT: 0.0455,

    // Progressive / top marginal rate states
    AL: 0.05,
    AZ: 0.025,
    AR: 0.039,
    CA: 0.133,
    CT: 0.0699,
    DE: 0.066,
    GA: 0.0539,
    HI: 0.11,
    ID: 0.05695,
    IA: 0.038,
    KS: 0.0558,
    LA: 0.03,
    ME: 0.0715,
    MD: 0.0575,
    MN: 0.0985,
    MS: 0.044,
    MO: 0.047,
    MT: 0.059,
    NE: 0.052,
    NJ: 0.1075,
    NM: 0.059,
    NY: 0.109,
    ND: 0.025,
    OH: 0.035,
    OK: 0.0475,
    OR: 0.099,
    RI: 0.0599,
    SC: 0.062,
    VT: 0.0875,
    VA: 0.0575,
    WV: 0.0482,
    WI: 0.0765,

    // Default for unknown states
    US: 0,
    DC: 0.1075,
};
